import { RequestLog } from '@engine/models'

import { ActivityTimeline } from '#components/ActivityTimeline'
import { EmptyState } from '#components/EmptyState'
import { ErrorsSection } from '#components/ErrorsSection'
import { KeyValueDisplay } from '#components/KeyValueDisplay'
import { RequestLogSections } from '#components/RequestLogSections'
import { formatDateTime } from '#utils/format'

import { TenderStatusBadge } from './TenderStatusBadge'

interface TenderDetailsProps {
  tender: RequestLog | null
}

const TenderDetails = ({ tender }: TenderDetailsProps) => {
  if (!tender) {
    return <EmptyState title="Select a tender to view details" />
  }

  const responseContent = tender.tenantResponse?.content as any
  const errorType = responseContent?.pickup?.errorType
  const errors = responseContent?.pickup?.errors

  return (
    <div className="space-y-6">
      {/* Overview Section */}
      <KeyValueDisplay
        items={[
          { label: 'External ID', value: tender.externalId },
          { label: 'Request ID', value: tender.requestId },
          { label: 'Tenant ID', value: tender.tenantId },
          { label: 'Type', value: tender.type },
          {
            label: 'Carrier',
            value:
              tender.carrierCode && tender.carrierCode.length > 0
                ? tender.carrierCode.join(', ')
                : 'N/A',
          },
          {
            label: 'Request Date',
            value: formatDateTime(tender.tenantRequest?.requestDate),
          },
          {
            label: 'Status',
            value: <TenderStatusBadge log={tender} />,
          },
          ...(errorType ? [{ label: 'Error Type', value: errorType }] : []),
        ]}
      />

      {/* Errors Section */}
      <ErrorsSection
        errors={errors}
        errorType={errorType}
        carrier={tender.carrierCode?.[0]}
        requestId={tender.requestId}
        externalId={tender.externalId}
        service="tender"
      />

      <RequestLogSections requestLog={tender} />

      <ActivityTimeline
        externalId={tender.externalId}
        emptyMessage="No traces or request logs found for this tender."
      />
    </div>
  )
}

export { TenderDetails }
